export default __webpack_public_path__ + "static/media/zero_balance_steps_icon.da11c8e4.svg";